import Icon from "@/assets/icons/Icon";

function install(Vue) {
  Vue.component("icon", Icon);
}

export default { install };
